// Prefer the public runtime env so a fork/deploy cannot retain a preview host.
// The only source is REACT_APP_BACKEND_URL, never window.location or a URL fallback.
const configuredUrl = window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_URL
  || process.env.REACT_APP_BACKEND_URL;
if (!configuredUrl?.trim()) throw new Error('REACT_APP_BACKEND_URL is required');
const parsed = new URL(configuredUrl.trim());
if (!['http:', 'https:'].includes(parsed.protocol) || parsed.username || parsed.password) {
  throw new Error('Invalid REACT_APP_BACKEND_URL');
}
export const BACKEND_URL = configuredUrl.trim().replace(/\/$/, '');